/**
 * Creates new cookie or removes cookie with negative expiration
 * @param  key       The key or identifier for the store
 * @param  value     Contents of the store
 * @param  duration     duration in seconds - creation defaults to 30 days
 */
export function createCookie(key, value, duration) {
    var date = new Date();
    date.setTime(date.getTime() + duration * 1000);
    var expires = "; expires=" + date.toUTCString();
    document.cookie = key + "=" + value + expires + "; path=/";
}
/**
 * Returns contents of cookie
 * @param  key       The key or identifier for the store
 */
export function readCookie(key) {
    var nameEQ = key + "=";
    var ca = document.cookie.split(';');
    for (var i = 0, max = ca.length; i < max; i += 1) {
        var c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1, c.length);
        }
        if (c.indexOf(nameEQ) === 0) {
            return c.substring(nameEQ.length, c.length);
        }
    }
    return null;
}
/**
 * Simple localStorage with Cookie Fallback
 * v.1.0.0
 *
 * USAGE:
 * ----------------------------------------
 * Set New / Modify:
 *   SimpleStore.set('my_key', 'some_value', 'optional - expiration in seconds')
 *
 * Retrieve:
 *   SimpleStore.get('my_key');
 *
 * Delete / Remove:
 *   SimpleStore.delete('my_key');
 */
var DEFAULT_EXPIRATION_IN_DAYS = 30;
var SimpleStore = (function () {
    var lsSupport = false;
    function isLocalStorageSupported() {
        try {
            localStorage.setItem('1', '1');
            localStorage.removeItem('1');
            return true;
        }
        catch (error) {
            return false;
        }
    }
    // Check for native support
    if (typeof localStorage !== 'undefined' && isLocalStorageSupported()) {
        lsSupport = true;
    }
    function deleteItem(key) {
        if (lsSupport) {
            // Native support
            localStorage.removeItem(key);
        }
        else {
            // Use cookie
            createCookie(key, '', -1);
        }
    }
    function formatValue(value) {
        var val = '';
        // Convert object values to JSON
        if (typeof value === 'object') {
            val = JSON.stringify(value);
        }
        else {
            val = value;
        }
        return val;
    }
    function set(key, value, expirationInSeconds) {
        var item;
        if (expirationInSeconds) {
            var now = new Date();
            var expiresAt = now.getTime() + expirationInSeconds * 1000;
            item = JSON.stringify({
                value: value,
                expiresAt: expiresAt,
            });
        }
        else {
            item = formatValue(value);
        }
        // Set the store
        if (lsSupport) {
            // Native support
            localStorage.setItem(key, item);
        }
        else {
            // Use Cookie
            createCookie(key, formatValue(value), expirationInSeconds
                ? expirationInSeconds
                : DEFAULT_EXPIRATION_IN_DAYS * 24 * 60 * 60);
        }
    }
    function get(key) {
        var data;
        // Get value
        if (lsSupport) {
            // Native support
            data = localStorage.getItem(key);
        }
        else {
            // Use cookie
            data = readCookie(key);
        }
        // Try to parse JSON...
        try {
            if (typeof data === 'string') {
                data = JSON.parse(data);
                if (data.expiresAt) {
                    var now = new Date();
                    // compare the expiresAt time of the item with the current time
                    if (now.getTime() > data.expiresAt) {
                        // If the item is expired, delete the item from storage
                        // and return null
                        deleteItem(key);
                        return null;
                    }
                    data = data.value;
                }
            }
        }
        catch (e) {
            // nothing to handle
        }
        return data;
    }
    return { set: set, get: get, delete: deleteItem };
})();
export default SimpleStore;
